import axios from 'axios';
import * as constant from "./constant";

let optionAxios = {
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        "x-api-source": "webapp"
    },
}

export const login = async (rest) => {
    const { store_id, location_id } = rest;
    if (!store_id) return false;

    const input = { store_id, location_id };
    const resp = await axios
        .post(constant.LOGIN, input, optionAxios)
        .then(r => r.data)
        .catch((error) => {
            console.log(error);
            return null;
        });

    if (!resp?.status) return false;

    const { token, store_details, StoreConfig, associated_details, table_details } = resp?.data || {};
    let config = StoreConfig && StoreConfig.length > 0 ? StoreConfig[0] : null;

    return {
        isAuthented: true,
        user: { store_id, location_id, token },
        store: store_details,
        storeConfig: config,
        associated_details: Array.isArray(associated_details) ? associated_details : [],
        table_details: table_details || null,
    };
};

export const isstore = () => {
    return true;
};
